import Vue from 'vue';
import { router } from './router/index';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueCryptojs from 'vue-cryptojs';
import App from './App.vue';

Vue.use(ElementUI);
Vue.use(VueCryptojs);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
